import { useIsTheme, Theme, Text } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import { useCheckoutSizes } from '../../utils/responsive'
import React, { FC } from 'react'

export const TooltipContent: FC = () => {
  const { t } = useTranslation()
  const isCashTheme = useIsTheme(Theme.Cash)
  const { textSize, smallTextSize } = useCheckoutSizes()
  const fontSize = isCashTheme ? smallTextSize : textSize
  return (
    <div>
      {!isCashTheme && <Text size={fontSize}>{t('paymentMethod:tooltipLineOne')}</Text>}
      {!isCashTheme && <p />}
      <Text size={fontSize}>{t('paymentMethod:tooltipLineTwo')}</Text>
    </div>
  )
}
